import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SpinnerOverlayService } from './spinner-overlay.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.scss'],
})
export class SpinnerOverlayComponent implements OnDestroy {
  spinnerVisible = false;
  spinnerSubscription: Subscription;

  constructor(private spinnerService: SpinnerOverlayService, private cdRef: ChangeDetectorRef) {
    this.spinnerSubscription = this.spinnerService.spinnerState.subscribe((v) => {
      this.spinnerVisible = v.visible;
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.spinnerSubscription.unsubscribe();
  }
}
